import { render, staticRenderFns } from "./DownLoadBottom.vue?vue&type=template&id=d1c251f0&scoped=true"
import script from "./DownLoadBottom.vue?vue&type=script&lang=js"
export * from "./DownLoadBottom.vue?vue&type=script&lang=js"
import style0 from "./DownLoadBottom.vue?vue&type=style&index=0&id=d1c251f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c251f0",
  null
  
)

export default component.exports